/* istanbul ignore file */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createStore } from '@vfde-sails/core';
import GlasfaserVfp from './container/GlasfaserVfp';
import { trackingMiddleware } from '@vfde-sails/tracking';

createStore({}, [trackingMiddleware]);
GlasfaserVfp();
